import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "intro"
}
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Welcome to the Memphis Lions Club")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" This website is your portal to the Memphis Metaverse, a digital playground for you to socialize, create, compete in, and enjoy. ")
const _hoisted_5 = { class: "d-flex align-items-center justify-content-evenly mt-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Click & Drag to Explore ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Scroll to zoom in & out ")

import { reactive, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeInstruction',
  setup(__props) {

const data = reactive({ showIntro: false });

onMounted(() => {
  const showIntro = localStorage.getItem('showIntro');
  data.showIntro = showIntro ? !JSON.parse(showIntro).visited : true;

  setTimeout(() => {
    data.showIntro = false;
  }, 15 * 1000);
});

return (_ctx: any,_cache: any) => {
  const _component_b_card_title = _resolveComponent("b-card-title")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_b_img = _resolveComponent("b-img")!
  const _component_b_card_body = _resolveComponent("b-card-body")!
  const _component_b_card = _resolveComponent("b-card")!

  return (data.showIntro)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "intro-overlay",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (data.showIntro = false))
        }),
        _createVNode(_component_b_card, { class: "intro-card" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_b_card_title, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_b_card_body, null, {
              default: _withCtx(() => [
                _createVNode(_component_b_card_text, null, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_b_img, {
                      height: "60%",
                      src: require('@/assets/drag.png'),
                      alt: "Click and drag."
                    }, null, 8, ["src"]),
                    _createVNode(_component_b_card_text, { class: "text-uppercase font-weight-bold mt-3" }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_b_img, {
                      height: "60%",
                      src: require('@/assets/scroll.png'),
                      alt: "Scroll"
                    }, null, 8, ["src"]),
                    _createVNode(_component_b_card_text, { class: "text-uppercase font-weight-bold mt-3" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})